var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 90,
    viewBox: "0 0 102 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.5858 44.4961C92.8987 47.9082 50.9801 89 50.9801 89C50.9801 89 9.1013 47.9728 6.4142 44.5606C3.72711 41.1485 0.610083 34.6947 1.04002 25.2577C1.46996 15.8207 9.1013 8.45704 12.8632 5.95481C16.446 3.63131 25.2916 -0.544039 32.1705 1.60073C40.7692 4.28169 41.3065 5.35407 50.9801 13.3969C60.6536 5.35407 61.191 4.2817 69.7897 1.60074C76.6687 -0.544027 85.554 3.56678 89.1368 5.89028C92.8987 8.3925 100.53 15.7562 100.96 25.1932C101.39 34.6302 98.2729 41.084 95.5858 44.4961Z",
    fill: "#F60606",
    stroke: "#F60606",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeart);
export default __webpack_public_path__ + "static/media/bg-heart.9966ff4bca32caf26815d224a0c431db.svg";
export { ForwardRef as ReactComponent };